import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

export const COMING_SOON = false;

export const CartProvider = ({ children }) => {
    const [items, setItems] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem("tl_cart") || "[]");
        } catch {
            return [];
        }
    });
    const [open, setOpen] = useState(false);

    useEffect(() => {
        localStorage.setItem("tl_cart", JSON.stringify(items));
    }, [items]);

    const add = (product, qty = 1) => {
        setItems((prev) => {
            const found = prev.find((i) => i.product.id === product.id);
            if (found) {
                return prev.map((i) =>
                    i.product.id === product.id ? { ...i, qty: i.qty + qty } : i,
                );
            }
            return [...prev, { product, qty }];
        });
        setOpen(true);
    };

    const remove = (id) => setItems((prev) => prev.filter((i) => i.product.id !== id));
    const setQty = (id, qty) =>
        setItems((prev) =>
            qty <= 0
                ? prev.filter((i) => i.product.id !== id)
                : prev.map((i) => (i.product.id === id ? { ...i, qty } : i)),
        );
    const clear = () => setItems([]);

    const value = useMemo(
        () => ({
            items,
            open,
            setOpen,
            add,
            remove,
            setQty,
            clear,
            count: items.reduce((s, i) => s + i.qty, 0),
            subtotal: items.reduce((s, i) => s + i.qty * i.product.price, 0),
        }),
        [items, open],
    );

    return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};

export const useCart = () => useContext(CartContext);
